import { Grid, Stack, TextField } from '@hiiretail/react-foundation-ui';
import {
  ReceiptFormData,
  CustomerInformation,
  CUSTOMER_INFORMATION_DEFAULT_VALUES,
} from 'common/receipt.types';
import { countryPattern } from 'common/utils/validationPattern';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

const customerInfoFields = Object.keys(
  CUSTOMER_INFORMATION_DEFAULT_VALUES,
) as (keyof CustomerInformation)[];

export const CustomerInfoForm = () => {
  const intl = useIntl();

  const {
    control,
    formState: { errors },
  } = useFormContext<ReceiptFormData>();

  return (
    <Grid item xs="auto">
      <Stack flexDirection="row" gap={3} flexWrap="wrap">
        {customerInfoFields.map((input) => (
          <Controller
            key={input}
            name={`customer.${input}`}
            control={control}
            rules={{
              pattern: input === 'country'
                ? {
                  value: countryPattern,
                  message: intl.formatMessage({
                    id: 'receipt.customer.country.error',
                    defaultMessage: 'Invalid country code. Use ISO 3166-1 format.',
                  }),
                }
                : undefined
            }}
            render={({ field }) => (
              <TextField
                label={intl.formatMessage({ id: `receipt.customer.${input}` })}
                size="small"
                {...field}
                sx={{ flex: '1 1 20%' }}
                error={input === 'country' && !!errors.customer?.country}
                helperText={input === 'country' && errors.customer?.country?.message}
              />
            )}
          />
        ))}
      </Stack>
    </Grid>
  );
};
